import Cookies from 'js-cookie'
const TokenKey = '__token__'
const TokenDomain = '.helixiechuang.com'
const UrlKey = '__redirect_url__'
const UserKey = '__user__'

const options = {
  domain: TokenDomain
}

// 获取用户token
export function getToken(): string | void {
  return Cookies.get(TokenKey)
}

// 设置用户token
export function setToken(token: string) {
  return Cookies.set(TokenKey, token, options)
}

// 删除用户token
export function removeToken() {
  return Cookies.remove(TokenKey, options)
}

export function getRedirectUrl() {
  return Cookies.get(UrlKey)
}

export function getUser() {
  return Cookies.get(UserKey)
}

export function setUser(token: string) {
  return Cookies.set(UserKey, token, options)
}

export function removeUser() {
  return Cookies.remove(UserKey, options)
}
